let filterWrapper = document.querySelector('.filter__sort');
if(filterWrapper) {
    filterPerson();
}
function filterPerson() {
    let filterMenuAll = document.querySelectorAll('.filter__menu');
    let createClose = `
        <button class="filter__list-close">
            <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.34424 1L16.9998 16.6365" stroke="white" stroke-linejoin="bevel"/>
                <path d="M1 16.6365L16.6556 1" stroke="white" stroke-linejoin="bevel"/>
            </svg>
        </button>
    `;

    filterMenuAll.forEach(menu => {
        let listMenuAll = menu.querySelectorAll('li');
        listMenuAll.forEach(list => {
            if(list.classList.contains('active')) {
                list.insertAdjacentHTML('beforeend', createClose);
            }
        })
    });

    filterWrapper.addEventListener('click', (e) => {
        let target = e.target;
        if(target.closest('li') !== null) {
            if (!target.closest('li').classList.contains('active')) {
                addItem(target.closest('li'))
            }
            else {
                removeItem(target.closest('li'));
            }
        }
    });

    function addItem(element) {
        element.classList.add('active');
        element.insertAdjacentHTML('beforeend', createClose)
    }
    function removeItem(element) {
        element.classList.remove('active');
        element.querySelector('.filter__list-close').remove();
    }

}

function widthChecked() {
    let windowWidth = document.body.clientWidth;
    let mediaSize = 920;
    if (windowWidth <= mediaSize) {

    }
    if (windowWidth > mediaSize) {

    }
}
widthChecked();
function filterMobile() {

    let filterHead = document.querySelectorAll('.filter__menu-head');

    filterHead.forEach(item => {
        item.addEventListener('click', () => {
            let content = $(item).next();
            content.slideToggle()
        })
    })

    window.addEventListener('resize', function(event) {
        widthChecked();
    }, true);
}
filterMobile();
